<template>
  <main class="main mobile_estimate_detail" role="main" v-if="isCompleted">
    <div class="main_con">
      <div class="detail_wrap">
        <div class="detail_top">
          <div class="top_1">
            <div class="top_1_img">
              <img :src="mobileRequestView.deviceImage" alt="" />
            </div>
            <div class="top_1_txt">
              <div class="txt_1">
                {{ mobileRequestView.modelName }}
              </div>
              <div class="txt_2">
                {{ mobileRequestView.deviceColor }}
              </div>
            </div>
          </div>
        </div>
        <div class="detail_con">
          <div class="detail_con_wrap">
            <div class="con_1">
              <div class="con_1_wrap">
                <div class="con_1_img">
                  <img
                    v-if="mobileEstimateDetail.estimateStore.storeProfile"
                    :src="mobileEstimateDetail.estimateStore.storeProfile"
                    alt=""
                  />

                  <img
                    v-else
                    :src="
                      setShopProfileImg(
                        mobileEstimateDetail.estimateStore.storeName,
                        mobileEstimateDetail.estimateStore.storeId,
                      )
                    "
                    alt=""
                  />

                  <img
                    v-if="mobileEstimateDetail.estimateStore.cert === 1"
                    class="mark"
                    src="@/assets/front/images/new/icon_consent_s.png"
                  />
                </div>
                <div class="con_1_txt">
                  <div class="con_txt_1">
                    <div class="txt_2">
                      {{ mobileEstimateDetail.estimateStore.storeName }}
                    </div>
                  </div>
                  <div class="con_txt_2">
                    <div class="txt">
                      휴대폰개통
                      <span
                        >{{
                          mobileEstimateDetail.estimateStore.mobileSaleCnt
                        }}건</span
                      >
                    </div>
                    <div class="txt">
                      <img
                        src="@/assets/front/images/v2/icons/ic_star_on.svg"
                      />
                      <span>
                        {{
                          mobileEstimateDetail.estimateStore.evaluationScore
                        }}(
                        {{ mobileEstimateDetail.estimateStore.reviewCnt }}건)
                      </span>
                    </div>
                  </div>
                </div>
                <div v-if="type == 'VIEW'">
                  <button
                    class="btn_chat closed"
                    v-if="
                      isCounselClosed(
                        mobileEstimateDetail.estimateStore.counselDay,
                        mobileEstimateDetail.estimateStore.counselStart,
                        mobileEstimateDetail.estimateStore.counselEnd,
                      )
                    "
                  >
                    휴무
                  </button>
                  <button
                    class="btn_chat"
                    v-else-if="mobileEstimateDetail.chat == 0"
                    @click="mobileChat(mobileEstimateDetail.chat)"
                  >
                    상담하기
                  </button>
                  <button
                    class="btn_chat ing"
                    v-else-if="mobileEstimateDetail.chat > 0"
                    @click="
                      enterChatRoom(
                        mobileEstimateDetail.storeId,
                        mobileEstimateDetail.chat,
                      )
                    "
                  >
                    상담 중
                  </button>
                </div>
              </div>
            </div>
            <div class="con_2">
              <div class="estimate_date">
                {{ getCreateAt(mobileEstimateDetail.estimatedAt) }}
              </div>
              <div class="con_txt_1">
                <span>
                  {{
                    mobileEstimateDetail.payType == 'SUPPORT'
                      ? '공시지원기준(단말할인)'
                      : '선택약정기준(요금할인)'
                  }}
                </span>
                견적을 드립니다!
              </div>
              <div
                v-if="mobileEstimateDetail.joinType == 'MNP'"
                class="con_txt_2"
              >
                번호이동(휴대폰번호 그대로 통신사 변경)
              </div>
              <div
                v-else-if="mobileEstimateDetail.joinType == 'CHANGE'"
                class="con_txt_2"
              >
                기기변경(기존통신사 그대로 휴대폰 변경)
              </div>
              <div
                v-else-if="mobileEstimateDetail.joinType == 'NEW'"
                class="con_txt_2"
              >
                신규가입(새로운 번호로 통신사 가입)
              </div>
            </div>
            <div class="con_2_1">
              <div class="sec_con">
                <div class="txt_1">통신사</div>
                <div class="txt_3 h40">
                  {{ mobileRequestView.telecomName }}
                </div>
              </div>
              <div class="sec_con">
                <div class="txt_1">가입 월 정액</div>
                <div class="txt_2">
                  {{ toCurrency(mobileEstimateDetail.joinPlanPrice) }}원
                </div>
                <div class="txt_3">
                  {{ toCurrency(mobileEstimateDetail.joinMonthlyRate) }}원
                </div>
              </div>
              <div class="sec_con">
                <div class="txt_1">단말기 구입가</div>
                <div class="txt_2">
                  {{ toCurrency(mobileEstimateDetail.factoryPrice) }}원
                </div>
                <div class="txt_3 rd">
                  {{ toCurrency(mobileEstimateDetail.principal) }}원
                </div>
              </div>
            </div>
            <div class="con_3">
              <div class="con_txt_3">
                사용 중인 결합 할인(ex:가족할인)과 카드혜택 등이 적용되면<br />요금은
                더 낮아집니다.
              </div>
            </div>
            <div class="con_4">
              <div class="con_4_info">
                <div class="info_list">
                  <div class="info_title">단말 정보</div>
                  <div class="info_con_list">
                    <div class="info_con">
                      <div class="txt_1">출고가</div>
                      <div class="txt_2">
                        {{ toCurrency(mobileEstimateDetail.factoryPrice) }}원
                      </div>
                    </div>
                    <div
                      class="info_con"
                      v-if="mobileEstimateDetail.payType == 'SUPPORT'"
                    >
                      <div class="txt_1 df">
                        공시지원금
                        <img
                          :src="
                            require('@/assets/front/images/v2/icons/ic_check_mint.svg')
                          "
                        />
                      </div>
                      <div class="txt_2">
                        <span v-if="mobileEstimateDetail.supportMoney > 0"
                          >-</span
                        >
                        {{ toCurrency(mobileEstimateDetail.supportMoney) }}원
                      </div>
                    </div>
                    <div
                      class="info_con"
                      v-if="
                        mobileEstimateDetail.payType == 'SUPPORT' &&
                          mobileEstimateDetail.joinType == 'MNP'
                      "
                    >
                      <div class="txt_1">전환지원금</div>
                      <div class="txt_2">
                        {{ toCurrency(mobileEstimateDetail.supportMoneyMnp) }}원
                      </div>
                    </div>
                    <div class="info_con">
                      <div class="txt_3">매장지원금</div>
                      <div class="txt_3">
                        -
                        {{
                          toCurrency(mobileEstimateDetail.storeSupportMoney)
                        }}원
                      </div>
                    </div>
                    <div class="info_con">
                      <div class="txt_1">할부원금(단말기 구입가)</div>
                      <div class="txt_2">
                        {{ toCurrency(mobileEstimateDetail.principal) }}원
                      </div>
                    </div>
                    <div class="info_con">
                      <div class="txt_1">할부이자</div>
                      <div class="txt_2">
                        {{ toCurrency(mobileEstimateDetail.totalInterest) }}원
                      </div>
                    </div>
                    <div class="info_con">
                      <div class="txt_4">월 할부금(24개월)</div>
                      <div class="txt_5">
                        {{
                          toCurrency(mobileEstimateDetail.monthlyInstallment)
                        }}원
                      </div>
                    </div>
                  </div>
                </div>
                <div class="info_list">
                  <div class="info_title">
                    가입 월 요금 정보
                  </div>
                  <div class="info_con_list">
                    <div class="info_con">
                      <div class="txt_1">요금제</div>
                      <div class="txt_2">
                        {{ mobileEstimateDetail.joinPlanInfo.planName }}
                      </div>
                    </div>
                    <div class="info_con">
                      <div class="txt_1">요금제 유지기간</div>
                      <div class="txt_2">
                        {{ getJoinPlanDuty(mobileEstimateDetail.joinPlanDuty) }}
                      </div>
                    </div>
                    <div class="info_con">
                      <div class="txt_1">월정액</div>
                      <div class="txt_2">
                        {{
                          toCurrency(mobileEstimateDetail.joinPlanInfo.price)
                        }}원
                      </div>
                    </div>
                    <div
                      class="info_con"
                      v-if="mobileEstimateDetail.payType == 'PLAN'"
                    >
                      <div class="txt_1 df">
                        선택약정할인(24개월)
                        <img
                          :src="
                            require('@/assets/front/images/v2/icons/ic_check_mint.svg')
                          "
                        />
                      </div>
                      <div class="txt_2">
                        -
                        {{ toCurrency(mobileEstimateDetail.joinPlanDcMoney) }}원
                      </div>
                    </div>
                    <div class="info_con">
                      <div class="txt_4">월 통신비</div>
                      <div class="txt_5">
                        {{ toCurrency(mobileEstimateDetail.joinMonthlyRate) }}원
                      </div>
                    </div>
                    <div class="info_con_2">
                      <div class="con_2_txt">
                        <div class="txt_1">
                          <img
                            src="@/assets/front/images/new/i_es_m_01.svg"
                            alt=""
                          />
                        </div>
                        <div class="txt_2">
                          {{ mobileEstimateDetail.joinPlanInfo.voice }}
                        </div>
                      </div>
                      <div class="con_2_txt">
                        <div class="txt_1">
                          <img
                            src="@/assets/front/images/new/i_es_m_02.svg"
                            alt=""
                          />
                        </div>
                        <div class="txt_2">
                          {{ mobileEstimateDetail.joinPlanInfo.sms }}
                        </div>
                      </div>
                      <div class="con_2_txt">
                        <div class="txt_1">
                          <img
                            src="@/assets/front/images/new/i_es_m_03.svg"
                            alt=""
                          />
                        </div>
                        <div class="txt_2">
                          {{ mobileEstimateDetail.joinPlanInfo.data }}
                        </div>
                      </div>
                      <div class="con_2_txt">
                        <div class="txt_1">
                          <img
                            src="@/assets/front/images/new/i_es_m_04.svg"
                            alt=""
                          />
                        </div>
                        <div class="txt_2">
                          {{ mobileEstimateDetail.joinPlanInfo.video }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="info_list"
                  v-if="mobileEstimateDetail.planInfo.planId > 0"
                >
                  <div class="info_title">
                    변경 후 요금 정보<span class="sub_txt"
                      >(요금제 유지기간 이후)</span
                    >
                  </div>
                  <div class="info_con_list">
                    <div class="info_con">
                      <div class="txt_1">요금제</div>
                      <div class="txt_2">
                        {{ mobileEstimateDetail.planInfo.planName }}
                      </div>
                    </div>
                    <div class="info_con">
                      <div class="txt_1">월정액</div>
                      <div class="txt_2">
                        {{ toCurrency(mobileEstimateDetail.planInfo.price) }}원
                      </div>
                    </div>
                    <div
                      class="info_con"
                      v-if="mobileEstimateDetail.payType == 'PLAN'"
                    >
                      <div class="txt_1 df">
                        선택약정할인(24개월)
                        <img
                          :src="
                            require('@/assets/front/images/v2/icons/ic_check_mint.svg')
                          "
                        />
                      </div>
                      <div class="txt_2">
                        -
                        {{ toCurrency(mobileEstimateDetail.planDcMoney) }}원
                      </div>
                    </div>
                    <div class="info_con">
                      <div class="txt_4">월 통신비</div>
                      <div class="txt_5">
                        {{ toCurrency(mobileEstimateDetail.monthlyRate) }}원
                      </div>
                    </div>
                    <div class="info_con_2">
                      <div class="con_2_txt">
                        <div class="txt_1">
                          <img
                            src="@/assets/front/images/new/i_es_m_01.svg"
                            alt=""
                          />
                        </div>
                        <div class="txt_2">
                          {{ mobileEstimateDetail.planInfo.voice }}
                        </div>
                      </div>
                      <div class="con_2_txt">
                        <div class="txt_1">
                          <img
                            src="@/assets/front/images/new/i_es_m_02.svg"
                            alt=""
                          />
                        </div>
                        <div class="txt_2">
                          {{ mobileEstimateDetail.planInfo.sms }}
                        </div>
                      </div>
                      <div class="con_2_txt">
                        <div class="txt_1">
                          <img
                            src="@/assets/front/images/new/i_es_m_03.svg"
                            alt=""
                          />
                        </div>
                        <div class="txt_2">
                          {{ mobileEstimateDetail.planInfo.data }}
                        </div>
                      </div>
                      <div class="con_2_txt">
                        <div class="txt_1">
                          <img
                            src="@/assets/front/images/new/i_es_m_04.svg"
                            alt=""
                          />
                        </div>
                        <div class="txt_2">
                          {{ mobileEstimateDetail.planInfo.video }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="info_list"
                  v-if="mobileEstimateDetail.planInfo.planId > 0"
                >
                  <div class="info_title">
                    최종 월 납부금액<span class="sub_txt"
                      >(월 통신비 + 단말기 할부금)</span
                    >
                  </div>
                  <div class="info_con_list">
                    <div class="info_con">
                      <div class="txt_1">가입 후 6개월간</div>
                      <div class="txt_2">
                        월
                        {{ toCurrency(mobileEstimateDetail.joinTotalPrice) }}원
                      </div>
                    </div>
                    <div class="info_con">
                      <div class="txt_4">6개월 이후 예상</div>
                      <div class="txt_5">
                        월 {{ toCurrency(mobileEstimateDetail.totalPrice) }}원
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="con_5_0">
              <div class="con_5_0_title">구매 방식</div>
              <div class="con_5_0_txt">
                <div
                  class="store_visit"
                  v-if="mobileEstimateDetail.openVisit == 1"
                >
                  <img
                    :src="
                      require('@/assets/front/images/v2/icons/ic_chat_btn_store.svg')
                    "
                  />
                  <div class="txt">매장방문</div>
                </div>
                <div
                  class="none_face"
                  v-if="mobileEstimateDetail.openOnline == 1"
                >
                  <img
                    :src="
                      require('@/assets/front/images/v2/icons/i_box_01.svg')
                    "
                  />
                  <div class="txt">비대면</div>
                </div>
              </div>
            </div>
            <div class="con_5" v-if="mobileEstimateDetail.giftItem">
              <div class="con_5_title">제공 사은품</div>
              <div class="con_5_txt">
                {{ mobileEstimateDetail.giftItem }}
              </div>
            </div>
            <div class="con_6" v-if="mobileEstimateDetail.supServiceName1">
              <div class="con_6_title">부가서비스</div>
              <div class="con_6_txt">
                <ul>
                  <li
                    v-if="
                      mobileEstimateDetail.supServiceName1 ||
                        mobileEstimateDetail.supServiceName2 ||
                        mobileEstimateDetail.supServiceName3 ||
                        mobileEstimateDetail.supServiceName4 ||
                        mobileEstimateDetail.supServiceName5
                    "
                  >
                    {{ mobileEstimateDetail.supServiceName1 }}({{
                      toCurrency(mobileEstimateDetail.supServicePrice1)
                    }}원) - {{ mobileEstimateDetail.supServiceDuty1 }} 유지
                  </li>
                  <li v-if="mobileEstimateDetail.supServiceName2">
                    {{ mobileEstimateDetail.supServiceName2 }}({{
                      toCurrency(mobileEstimateDetail.supServicePrice2)
                    }}원) - {{ mobileEstimateDetail.supServiceDuty2 }} 유지
                  </li>
                  <li v-if="mobileEstimateDetail.supServiceName3">
                    {{ mobileEstimateDetail.supServiceName3 }}({{
                      toCurrency(mobileEstimateDetail.supServicePrice3)
                    }}원) - {{ mobileEstimateDetail.supServiceDuty3 }} 유지
                  </li>
                  <li v-if="mobileEstimateDetail.supServiceName4">
                    {{ mobileEstimateDetail.supServiceName4 }}({{
                      toCurrency(mobileEstimateDetail.supServicePrice4)
                    }}원) - {{ mobileEstimateDetail.supServiceDuty4 }} 유지
                  </li>
                  <li v-if="mobileEstimateDetail.supServiceName5">
                    {{ mobileEstimateDetail.supServiceName5 }}({{
                      toCurrency(mobileEstimateDetail.supServicePrice5)
                    }}원) - {{ mobileEstimateDetail.supServiceDuty5 }} 유지
                  </li>
                </ul>
              </div>
            </div>
            <div class="con_6" v-if="mobileEstimateDetail.insuranceName">
              <div class="con_6_title">의무 보험</div>
              <div class="con_6_txt">
                <ul>
                  <li v-if="mobileEstimateDetail.insuranceName">
                    {{ mobileEstimateDetail.insuranceName }}({{
                      toCurrency(mobileEstimateDetail.insurancePrice)
                    }}원) - {{ mobileEstimateDetail.insuranceDuty }} 유지
                  </li>
                </ul>
              </div>
            </div>
            <div class="con_7" v-if="mobileEstimateDetail.info">
              <div class="con_7_title">기타조건</div>
              <div
                class="con_7_txt"
                v-html="$options.filters.nl2br(mobileEstimateDetail.info)"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btm_btn" v-if="type == 'VIEW'">
      <div class="btn_wrap">
        <button
          class="btn closed"
          v-if="
            isCounselClosed(
              mobileEstimateDetail.estimateStore.counselDay,
              mobileEstimateDetail.estimateStore.counselStart,
              mobileEstimateDetail.estimateStore.counselEnd,
            )
          "
        >
          <i class="i_nav_chat_white"></i>휴무
        </button>
        <button
          class="btn"
          v-else-if="mobileEstimateDetail.chat == 0"
          @click="mobileChat(mobileEstimateDetail.chat)"
        >
          <i class="i_nav_chat_white"></i>상담하기
        </button>
        <button
          class="btn ing"
          v-else-if="mobileEstimateDetail.chat > 0"
          @click="
            enterChatRoom(
              mobileEstimateDetail.storeId,
              mobileEstimateDetail.chat,
            )
          "
        >
          <i class="i_nav_chat_white"></i>상담 중
        </button>
      </div>
    </div>
    <SafePhoneModal
      ref="safePhoneModal"
      @close="closeSafePhoneModal"
      @agreeChat="agreeChat"
      @normalChat="normalChat"
    ></SafePhoneModal>
  </main>
</template>
<script>
import * as util from '@common/lib/common/utils.js';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

import {
  mapActions as mobileMapActions,
  mapGetters as mobileMapGetters,
} from '@common/store/modules/mobile';
import * as mobileTypes from '@common/store/modules/mobile/types';

import {
  mapActions as chatMapActions,
  mapState as chatMapState,
  mapGetters as chatMapGetters,
} from '@common/store/modules/chat';
import * as chatActions from '@common/store/modules/chat/types';
import * as chatGetters from '@common/store/modules/chat/getters';

import {
  mapActions as safeNumberMapActions,
  mapGetters as safeNumberMapGetters,
} from '@common/store/modules/safeNumber';
import * as safeNumberTypes from '@common/store/modules/safeNumber/types';

import SafePhoneModal from '@/front/customer/views/mobile/modal/SafePhoneModal';

export default {
  components: {
    SafePhoneModal,
  },
  data() {
    return {
      isCompleted: false,
      selectStoreId: 0,
      isChatView: false,
      useChat: 0,
      chatCnt: 0,
      telecomLogo: '',
      telecomInfo: [
        {
          telecomId: 'SKT',
          isCheapPhone: false,
          telecomImg: 'es_logo_skt.png',
        },
        { telecomId: 'KT', isCheapPhone: false, telecomImg: 'es_logo_kt.png' },
        {
          telecomId: 'LGUPLUS',
          isCheapPhone: false,
          telecomImg: 'es_logo_uplus.png',
        },
        {
          telecomId: 'HELLOSKT',
          isCheapPhone: true,
          telecomImg: 'es_logo_hellovision_skt.png',
        },
        {
          telecomId: 'HELLOKT',
          isCheapPhone: true,
          telecomImg: 'es_logo_hellovision_kt.png',
        },
        {
          telecomId: 'HELLOUPLUS',
          isCheapPhone: true,
          telecomImg: 'es_logo_hellovision_uplus.png',
        },
        {
          telecomId: '7MOBILE',
          isCheapPhone: true,
          telecomImg: 'es_logo_sk_7_mobile.png',
        },
        {
          telecomId: 'MMOBILE',
          isCheapPhone: true,
          telecomImg: 'es_logo_kt_mobile.png',
        },
        {
          telecomId: 'UPLUSE',
          isCheapPhone: true,
          telecomImg: 'es_logo_uplus_mobile.png',
        },
        { telecomId: 'SKYLIFE', isCheapPhone: true, telecomImg: '' },
      ],
      isUpdated: false,
      selectId: '',
      planDuty: [
        { name: '0개월 (없음)', value: '0' },
        { name: '1개월', value: '1' },
        { name: '2개월', value: '2' },
        { name: '3개월', value: '3' },
        { name: '4개월', value: '4' },
        { name: '5개월', value: '5' },
        { name: '6개월', value: '6' },
        { name: '0개월 (없음)', value: '0M' },
        { name: '1개월', value: '1M' },
        { name: '2개월', value: '2M' },
        { name: '3개월', value: '3M' },
        { name: '4개월', value: '4M' },
        { name: '5개월', value: '5M' },
        { name: '6개월', value: '6M' },
        { name: 'D+93일', value: 'D+93' },
        { name: 'D+95일', value: 'D+95' },
        { name: 'D+123일', value: 'D+123' },
        { name: 'D+125일', value: 'D+125' },
        { name: 'M+3개월', value: 'M+3' },
        { name: 'M+4개월', value: 'M+4' },
        { name: 'M+6개월', value: 'M+6' },
      ],
      type: '',
    };
  },
  async created() {
    this.type = this.$route.query.type == '' ? '' : this.$route.query.type;
    await this.getRequestView();
    await this.getEstimateDetail();

    this.telecomLogo = this.isTelecomLogo();
    this.isCompleted = true;

    if (this.mobileEstimateDetail.visible == 0) {
      await this.setVisible(parseInt(this.$route.query.estimateId, 10));
    }
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    nl2br(val) {
      return String(val)
        .split('\n')
        .join('<br />');
    },
  },
  watch: {},
  mounted() {},
  updated() {},
  computed: {
    ...mobileMapGetters({
      mobileRequestView: mobileTypes.MOBILE_REQUEST_VIEW,
      mobileEstimateList: mobileTypes.MOBILE_ESTIMATE_LIST,
      mobileEstimateDetail: mobileTypes.MOBILE_ESTIMATE_DETAIL,
    }),
    ...chatMapGetters({
      chatroom_with: chatGetters.CHATROOMS_WITH,
      chatroom: chatGetters.CHATROOM,
    }),
    ...safeNumberMapGetters({
      safeNumber: safeNumberTypes.SAFE_NUMBER,
    }),
  },
  methods: {
    ...mobileMapActions([
      mobileTypes.SELECT_MOBILE_REQUEST_VIEW,
      mobileTypes.UPDATE_MOBILE_REQUEST_CLOSE,
      mobileTypes.UPDATE_MOBILE_ESTIMATE_VISIBLE,
      mobileTypes.SELECT_MOBILE_ESTIMATE_DETAIL,
    ]),
    ...chatMapActions([
      chatActions.FETCH_CHATROOM_WITH_STORE,
      chatActions.CHATROOMS_WITH_RESET_STATE,
      chatActions.UPDATE_MEMBER_SCREEN_ACTIVED_ALL,
      chatActions.SEND_MOBILE_REQUEST,
      chatActions.FETCH_CHATROOM_CHATLISTTYPE,
      chatActions.CREATE_CHATROOM,
    ]),
    ...safeNumberMapActions([safeNumberTypes.GET_SAFE_NUMBER]),
    getJoinPlanDuty(joinPlanDuty) {
      console.log('joinPlanDuty');
      console.log(joinPlanDuty);
      const foundInfo = this.planDuty.find(info => info.value === joinPlanDuty);

      if (foundInfo == undefined) {
        return joinPlanDuty + '개월';
      }
      return foundInfo.name;
    },
    toCurrency(val) {
      return util.toCurrency(val);
    },
    getDateAt(dateAt) {
      return format(parseISO(dateAt), 'yyyy-MM-dd');
    },
    async getEstimateDetail() {
      const params = {
        callPart: 'CUSTOMER',
        // requestId: parseInt(this.$route.query.requestId, 10),
        id: parseInt(this.$route.query.estimateId, 10),
      };
      await this[mobileTypes.SELECT_MOBILE_ESTIMATE_DETAIL](params);

      console.log(params);
      console.log('mobileEstimateDetail');
      console.log(this.mobileEstimateDetail);
    },
    async getRequestView() {
      let params = {
        callPart: 'CUSTOMER',
        id: parseInt(this.$route.query.requestId, 10),
      };
      await this[mobileTypes.SELECT_MOBILE_REQUEST_VIEW](params);

      console.log(params);

      console.log('mobileRequestView');
      console.log(this.mobileRequestView);
    },
    isTelecomLogo() {
      const telecomId = this.mobileRequestView.telecomId;
      const foundInfo = this.telecomInfo.find(
        info => info.telecomId === telecomId,
      );

      return foundInfo.telecomImg;
    },
    storeAreaShort(area) {
      var areaShort = area.split(' ');
      return areaShort[2];
    },
    isCounselClosed(counselDay, counselStart, counselEnd) {
      let now = new Date();
      var week = new Array('7', '1', '2', '3', '4', '5', '6'); // 일, 월, 화, 수, 목, 금, 토

      let hours = now.getHours(); // 시
      let minutes = now.getMinutes(); // 분

      var startTime = counselStart.split(':');
      var endTime = counselEnd.split(':');

      // 있음, 영업함
      if (counselDay.indexOf(week[now.getDay()]) !== -1) {
        // 시간 확인
        if (parseInt(startTime[0]) <= hours && parseInt(endTime[0]) >= hours) {
          if (parseInt(endTime[1]) < minutes && parseInt(endTime[0]) == hours) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    setShopProfileImg(shopName, shopId) {
      let path = util.setShopProfile(shopName, shopId, '120x120', '20');

      return path;
    },
    async setVisible(id) {
      let params = {
        id: id,
      };
      await this[mobileTypes.UPDATE_MOBILE_ESTIMATE_VISIBLE](params);
    },
    getCreateAt(createAt) {
      return format(parseISO(createAt), 'yyyy.MM.dd HH:mm');
    },
    async mobileChat(chatCnt) {
      this[safeNumberTypes.GET_SAFE_NUMBER]({})
        .then(() => {
          this.$refs.safePhoneModal.safeNumber = this.safeNumber;
        })
        .catch(() => {});
      this.chatCnt = chatCnt;
      this.$refs.safePhoneModal.isOpen = true;
      util.nativeDisableBackKey();
    },
    closeSafePhoneModal() {
      util.nativeEnableBackKey();
      this.$refs.safePhoneModal.isOpen = false;
    },
    async agreeChat() {
      await this.chatSend('agree');
      await this.enterChatRoom(this.selectStoreId, 0);
    },
    async normalChat() {
      await this.chatSend('normal');
      await this.enterChatRoom(this.selectStoreId, 0);
    },
    async chatSend(sel) {
      var sendSafeNum = '';
      var sendType = '';

      if (sel == 'agree') {
        // 동의하고 상담하기
        sendSafeNum = this.$refs.safePhoneModal.safeNumber;
      } else if (sel == 'normal') {
        // 단순 상담만 진행
        sendSafeNum = '';
      }

      this.selectStoreId = this.mobileEstimateDetail.storeId;

      const params = {
        callTime: this.$refs.safePhoneModal.timeValue,
        estimateId: this.mobileEstimateDetail.id,
        requestId: this.mobileEstimateDetail.requestId,
        safeNum: sendSafeNum,
        sendType: sel,
        storeId: this.mobileEstimateDetail.storeId,
      };

      console.log('chatSend');
      console.log(params);

      await this[chatActions.SEND_MOBILE_REQUEST](params);
    },
    async enterChatRoom(storeId, chatCnt) {
      this.chatCnt = chatCnt;
      await this[chatActions.CHATROOMS_WITH_RESET_STATE]();
      this[chatActions.FETCH_CHATROOM_WITH_STORE]({
        chatRoomType: 'OneOnOne',
        storeId: storeId,
      }).then(() => {
        let name = 'chat.room';
        const params = {};
        if (this.chatroom_with.count == 0) {
          // name = 'chat.room.create';

          this[chatActions.CREATE_CHATROOM]({
            chatRoomType: 'OneOnOne',
            memberId: '',
            storeId: storeId,
            estimateId: undefined,
          }).then(() => {
            console.log('this.chatroom');
            console.log(this.chatroom);
            params.uuid = this.chatroom.uuid;
            params.createRoom = 'Y';

            console.log('paramsparamsparams');
            console.log(params);

            this.$router.push({
              name,
              params,
            });
          });
        } else {
          params.uuid = this.chatroom_with.content[0].uuid;

          if (this.chatCnt == 0) {
            // 휴대폰 채팅 체크
            this[chatActions.FETCH_CHATROOM_CHATLISTTYPE]({
              chatListType: 'P',
              chatRoomId: this.chatroom_with.content[0].id,
            });
          }

          this.$router.push({
            name,
            params,
          });
        }
      });
    },
  },
};
</script>
